import { render, staticRenderFns } from "./SolutionForm.vue?vue&type=template&id=2f00a3a0&scoped=true&lang=pug&"
import script from "./SolutionForm.vue?vue&type=script&lang=js&"
export * from "./SolutionForm.vue?vue&type=script&lang=js&"
import style0 from "./SolutionForm.vue?vue&type=style&index=0&id=2f00a3a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f00a3a0",
  null
  
)

export default component.exports